import React from 'react';
import { ClockIcon, DumbbellIcon, FlameIcon, LineChartIcon, ShuffleIcon, UtensilsIcon } from 'lucide-react';
const icons = {
  flame: FlameIcon,
  dumbbell: DumbbellIcon,
  shuffle: ShuffleIcon,
  utensils: UtensilsIcon,
  clock: ClockIcon,
  chart: LineChartIcon
};
export type IconName = keyof typeof icons;
export function IconByName({
  name,
  className
}: {
  name: IconName;
  className?: string;
}) {
  const Icon = icons[name];
  return <Icon className={className} aria-hidden="true" data-id="element-286" data-mp="3pi1y36mohpd2" />;
}